import React, { useCallback, useContext, useEffect, useRef, useState, } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { PlayerUIContext } from '@24i/player-ui';
import { IconName } from '../Icons';
import { Circle, FeedBackIcon } from './styled';
export const Feedback = ({ playerInstance, duration, className, styles, }) => {
    const { state: { relativeSeekValue, seekAction, dvrPoint }, } = useContext(PlayerUIContext);
    const [iconToBeDisplayed, setIconToBeDisplayed] = useState(null);
    const timeout = useRef();
    const showFeedback = useCallback((iconName) => {
        if (timeout.current)
            clearTimeout(timeout.current);
        setIconToBeDisplayed(null);
        setTimeout(() => {
            setIconToBeDisplayed(React.createElement(FeedBackIcon, { style: styles.icon, "data-test": "Feedback-Icon", className: "Feedback-Icon", name: iconName, color: "White" }));
        });
        timeout.current = setTimeout(() => {
            setIconToBeDisplayed(null);
        }, duration);
    }, [timeout.current]);
    const onPause = useCallback(() => {
        showFeedback(IconName.pause);
    }, []);
    const onPlay = useCallback(() => {
        showFeedback(IconName.play);
    }, []);
    useEffect(() => {
        if (!relativeSeekValue && !dvrPoint)
            return;
        const hasAdvanced = relativeSeekValue > 0;
        const relativeSeek = `${hasAdvanced ? 'forward' : 'rewind'}_10`;
        const absoluteSeekIcon = dvrPoint === 'end' ? 'gotolive' : 'restart';
        showFeedback(IconName[seekAction === 'absolute' ? absoluteSeekIcon : relativeSeek]);
    }, [relativeSeekValue, seekAction, dvrPoint]);
    useEventListener('play', onPlay, playerInstance);
    useEventListener('pause', onPause, playerInstance);
    return (iconToBeDisplayed && (React.createElement(Circle, { style: styles.container, "data-test": "Feedback-Circle", className: `Feedback-Circle ${className}`, duration }, iconToBeDisplayed)));
};
Feedback.defaultProps = {
    duration: 1000,
    className: '',
    styles: {
        container: null,
        icon: null,
    },
};
//# sourceMappingURL=index.js.map